// ============================================================================
// THEME CONFIGURATION — AstraFlux
// AUTO-GENERATED by /app/scripts/apply-theme.js  (site id: astraflux)
// Edit this file (or the source JSON at /app/themes/astraflux.json) to retheme.
// Tailwind colors are sourced from here at build time.
// ============================================================================

const theme = {
  "id": "astraflux",
  "siteId": "astraflux",
  "orderPrefix": "AFX",
  "brand": {
    "name": "AstraFlux",
    "short": "Astra",
    "legalName": "PT ASTRA FLUX DIGITAL"
  },
  "meta": {
    "title": "AstraFlux | Stellar Top-Up & Digital Voucher Operations",
    "description": "AstraFlux — gerbang transaksi energi kosmis untuk top-up game dan voucher digital Anda. Aliran secepat plasma, harga orbit terendah, aman tier-Galaxy.",
    "themeColor": "#00F5FF"
  },
  "assets": {
    "heroBg": "/hero-astraflux.png",
    "logo": "/logo-astraflux.svg"
  },
  "copy": {
    "hero": {
      "titleLine1": "Harness the Flux.",
      "titleLine2": "Power Up Your Game.",
      "subtitle": "Operasi top-up berkecepatan plasma dari orbit bumi. Transmisi instan membawa Diamond, UC, dan voucher digital langsung ke akun game-mu — aman, tanpa hambatan, sejalan arus energi kosmis.",
      "searchPlaceholder": "Scan orbit: cari game, voucher, atau kargo data..."
    },
    "features": [
      {
        "label": "Plasma Speed",
        "desc": "Drop instan secepat cahaya"
      },
      {
        "label": "Orbit Pricing",
        "desc": "Harga bersaing level atmosfer"
      },
      {
        "label": "Stellar Security",
        "desc": "Transkripsi orbital terenkripsi"
      },
      {
        "label": "Command Center",
        "desc": "Support 24/7 dari control room"
      }
    ],
    "cta": {
      "titlePrefix": "Daftar sebagai ",
      "titleHighlight": "Astra",
      "titleSuffix": " Commander",
      "subtitle": "Bergabung dengan aliansi reseller AstraFlux. Dapatkan akses ke harga tier orbit terendah, panel kontrol modular real-time, dan komunikasi langsung dengan pos komando.",
      "button": "Inisiasi Akses"
    },
    "footer": {
      "tagline": "Gerbang top-up digital terintegrasi kosmik. Kecepatan selevel arus plasma, stabilitas setegar konstelasi bintang — AstraFlux. Navigate the galaxy."
    }
  },
  "colors": {
    "primary": "#00FF88",
    "secondary": "#FF00AA",
    "accent": "#8A2BE2",
    "background": "#090314",
    "card": "#140B24",
    "border": "#25153E",
    "foreground": "#EBE5F5",
    "success": "#10B981",
    "destructive": "#EF4444",
    "gradientFrom": "#00FF88",
    "gradientTo": "#FF00AA"
  },
  "fonts": {
    "display": "'Orbitron', 'Rajdhani', sans-serif",
    "body": "'Plus Jakarta Sans', 'Inter', sans-serif",
    "mono": "'JetBrains Mono', monospace",
    "googleFontsUrl": "https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;800;900&family=Rajdhani:wght@500;600;700&family=Plus+Jakarta+Sans:wght@400;500;600&family=Inter:wght@400;500&display=swap"
  },
  "style": {
    "heroVisual": "astra-flux",
    "mascotGlow": "drop-shadow(0 0 20px rgba(0, 245, 255, 0.5)) drop-shadow(0 0 40px rgba(139, 92, 246, 0.25))",
    "heroAccent1": "bg-primary/15",
    "heroAccent2": "bg-secondary/10"
  }
};

module.exports = theme;
